import React, { useCallback, useEffect, useMemo } from 'react'
import { useInstData } from 'tyan/public/hooks'
import Grid from '../components/Grid'
import AnnouncementDetail from './AnnouncementDetail'

const Announcements = props => {
	const { setState, me: { state: { data } } } = useInstData(props)

	const getAnnouncements = useCallback(() => {
		Tyan.doPostEvent({
			event: 'GetAnnoucements',
			data: {},
			onEnd: ({ errorMessage, annoucements }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				// console.log('data:', annoucements)
				setState({ data: annoucements.map(o => ({ ...o, publishDate: Ext.Date.utcToLocal(new Date(o.publishDate)), Readed: o.Readed })) })
			}
		})
	}, [])

	const handleRead = getAnnouncements

	const handleClick = useCallback(args => {
		Tyan.pubForm.showDialog('公告详情', AnnouncementDetail, { data: args, onRead: handleRead }, { closable: true, height: '90%', width: '900px' })
		// console.log('annoucement click:', args)
	}, [])

	const columns = useMemo(() => {
		const subjectTemplate = props => {
			const { Readed: readed, Subject: subject } = props
			// console.log('props:', props)
			return <div style={{ width: '100%', display: 'flex', flexDirection: 'row', fontWeight: 600, color: readed ? 'var(--disabled-color)' : 'var(--base-color)' }}>
				<div className={`x-fa fa-envelope${readed ? '-open' : ''}-o`} style={{ marginRight: '5px' }} ></div>
				<div data-qoverflow='true' style={{ flex: 1, textOverflow: 'ellipsis', cursor: 'pointer', overflow: 'hidden', whiteSpace: 'nowrap' }} onClick={() => handleClick(props)}>{subject}</div>
			</div >
		}

		return [
			// { field: 'No', headerText: '编号', width: '120' },
			{ field: 'Subject', headerText: '主题', minWidth: '150', template: subjectTemplate },
			{ field: 'PublishDate', headerText: '日期', width: '120', type: 'Date', format: 'yyyy/MM/dd' }
		]
	}, [])

	useEffect(() => {
		getAnnouncements()
	}, [])

	return <Grid data={data} columns={columns} searchable />
}

export default Announcements